<template>
  <div class="eventComp_mode_6 eventComp_mode_container" v-show="currThemeObj">
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        @toParentEvent="toParentEventHandler"
        :isBroadCastList="themeClass === 'onlyDisplay'"
        :sportCompetitionType="sportCompetitionType"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
    </div>
  </div>
</template>

<script>
// 适用： 最普通表格 （篮球-本场数据-最上面的小节表格）
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_6',
  components: {
    multiLevelFold_table,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    competitorType: {
      type: String, //竞赛者的类型 A || D || T,
      default: '',
    },
    themeClass: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_6 刷新数据:', newVal, oldVal, this.currSportsDetail)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isScrollBottom: false,
      tableMode: 'eventComp_mode_6',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: null,
      tableCellDefaultWidthVw: 6.94,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      renderTeamColumnArr: [
        'BKB',
        'VVO',
        'WPO',
        'FBL',
        'VBV',
        'BK3',
        'HBL',
        'HOC',
        'ELS',
        'BBL',
        'SBL',
        'SQU',
        'RUG',
        'CKT',
        'CUR',
        'IHO',
      ],
      renderPlayerInforColumnArr: [
        'TTE',
        'BDM',
        'TEN',
        'KUR',
        'ELS',
        'BOX',
        'SQU',
        'MMA',
        'PDL',
        'TEQ',
        'TST',
      ],
      dynamicColumnSportsIdArr: ['BDM', 'TST'], //该大项的比赛，每次更新数据都会重新组装表头 tableColumnData
    }
  },
  beforeCreate() {},
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.onResizeEvent()
        // this.computedModeData({})
        console.debug('tabelData:', this.datas, this.competitorType)
        const keyArr = ['home', 'away']
        let table_headArr = []
        let tabelData = []
        if (this.competitorType === 'T') {
          table_headArr = [
            {
              name: '国家/地区',
              map_key_arr: ['team_logo', 'team_name'],
            },
          ]
          const origin_table_headArr =
            this.datas.home && this.datas.home.score_detail
              ? this.datas.home.score_detail
              : []
          origin_table_headArr.forEach((column) => {
            table_headArr.push({
              name: column.periodName ? column.periodName : '',
              map_key_arr: [column.periodCode],
            })
          })

          if (this.datas.table_head) {
            this.datas.table_head.forEach((headItem) => {
              if (headItem.map_key_arr && headItem.map_key_arr.length == 1) {
                table_headArr.push({
                  name: headItem.name,
                  map_key_arr: headItem.map_key_arr,
                })
              }
            })
          }

          tabelData = {
            data: keyArr.map((key) => {
              let rowData = {}
              rowData = this.datas[key]
              rowData.score = this.datas[key].score
              rowData.team_name = this.datas[key].team_name
              rowData.team_eng = this.datas[key].team_eng
              rowData.team_logo = this.datas[key].team_logo
              rowData.team_id = this.datas[key].team_id
              if (this.datas[key].is_win === false) {
                rowData.is_win = '负'
              } else if (this.datas[key].is_win === true) {
                rowData.is_win = '胜'
              }
              if (this.datas[key].score_detail) {
                this.datas[key].score_detail.forEach((scoreItem) => {
                  rowData[scoreItem.periodCode] = scoreItem.periodScore
                })
              }
              return rowData
            }),
            table_head: table_headArr,
          }
        } else if (
          this.renderPlayerInforColumnArr.includes(
            this.currSportsDetail.sportsId
          )
        ) {
          let isPlayerFlag = 'A'
          tabelData = {
            data: keyArr.map((key) => {
              let rowData = {}
              rowData = this.datas[key]
              rowData.score = this.datas[key].score
              rowData.team_name = this.datas[key].team_name
              rowData.team_eng = this.datas[key].team_eng
                ? this.datas[key].team_eng
                : ''
              rowData.team_logo = this.datas[key].team_logo
              if (this.datas[key].is_win === false) {
                rowData.is_win = '负'
              } else if (this.datas[key].is_win === true) {
                rowData.is_win = '胜'
              }

              if (this.datas[key].score_detail) {
                this.datas[key].score_detail.forEach((scoreItem) => {
                  rowData[scoreItem.periodCode] = scoreItem.periodScore
                })
              }
              rowData.playerList = []
              let playerListKey = ''
              if (this.datas[key].players) {
                playerListKey = 'players'
              } else if (this.datas[key].player_infos) {
                playerListKey = 'player_infos'
              }
              if (
                (this.datas[key]['competitorType'] &&
                  this.datas[key]['competitorType'] === 'D') ||
                (this.datas[key][playerListKey] &&
                  this.datas[key][playerListKey].length > 1)
              ) {
                this.datas[key][playerListKey].forEach((playerItem) => {
                  rowData.playerList.push(playerItem.player_name)
                })
                // rowData.playerListString = rowData.playerList.join(' / ')
                rowData.players = this.datas[key][playerListKey]
                isPlayerFlag = 'D'
              } else if (
                this.datas[key][playerListKey] &&
                this.datas[key][playerListKey].length === 1
              ) {
                const playerItem = this.datas[key][playerListKey][0]
                rowData.player_name = playerItem.player_name
                rowData.player_id = playerItem.player_id
                rowData.player_logo = playerItem.player_logo
                rowData.player_gender = playerItem.player_gender
                rowData.country_id = playerItem.country_id
                  ? playerItem.country_id
                  : null
                rowData.country_logo = playerItem.country_logo
                  ? playerItem.country_logo
                  : null
                rowData.country_name = playerItem.country_name
                  ? playerItem.country_name
                  : null
                isPlayerFlag = 'A'
              }
              return rowData
            }),
          }
          this.isPlayerFlag = isPlayerFlag
          if (isPlayerFlag === 'A') {
            table_headArr = [
              {
                name: '运动员',
                // map_key_arr: [
                //   'team_logo',
                //   'teamName',
                //   'playerName',
                //   'playerLogo',
                //   'playerGender',
                // ],
                map_key_arr: [
                  'team_logo',
                  'team_name',
                  'player_name',
                  'player_logo',
                  'player_gender',
                ],
              },
              // {
              //   name: '比分',
              //   map_key_arr: ['score'],
              // },
            ]
          } else if (isPlayerFlag === 'D') {
            table_headArr = [
              {
                name: '运动员',
                map_key_arr: ['team_logo', 'playerListString'],
              },
              // {
              //   name: '比分',
              //   map_key_arr: ['score'],
              // },
            ]
          }

          const origin_table_headArr =
            this.datas.home && this.datas.home.score_detail
              ? this.datas.home.score_detail
              : []
          origin_table_headArr.forEach((column) => {
            table_headArr.push({
              name: column.periodName,
              map_key_arr: [column.periodCode],
            })
          })

          if (this.datas.table_head) {
            this.datas.table_head.forEach((headItem) => {
              if (headItem.map_key_arr && headItem.map_key_arr.length == 1) {
                table_headArr.push({
                  name: headItem.name,
                  map_key_arr: headItem.map_key_arr,
                })
              }
            })
          }
          tabelData.table_head = table_headArr
        }

        console.debug('tabelData 1:', tabelData)
        this.computedModeData(tabelData)
      })
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      if (data && data.data) {
        this.tableTotal = data ? data.length : 0
        const table_headArr = data.table_head

        // 表头
        const headColumns = []
        table_headArr.forEach((colums, colIndex) => {
          if (colums && colums.map_key_arr.length < 2) {
            headColumns.push({
              colKey: colums.map_key_arr[0] ? colums.map_key_arr[0] : '',
              colTitle: colums.name ? colums.name : '',
            })
          }
        })

        const otherColumns = headColumns

        if (
          this.tableColumnData.length == 0 ||
          this.dynamicColumnSportsIdArr.includes(this.currSportsDetail.sportsId)
        ) {
          let tableColumnData = []
          let customColumn = null
          if (this.competitorType === 'T') {
            customColumn = {
              prop: 'teamLogo-teamName', //fristColumnPropArr.join('-'),
              label: '国家/地区',
              // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
              className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            }
          } else if (
            this.renderPlayerInforColumnArr.includes(
              this.currSportsDetail.sportsId
            )
          ) {
            if (this.isPlayerFlag === 'A') {
              customColumn = {
                prop: 'playerName-playerLogo-playerGender-teamLogo-teamName', //fristColumnPropArr.join('-'),
                label: '运动员',
                // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              }
            } else if (this.isPlayerFlag === 'D') {
              let prop = 'teamLogo-playerListString'
              if (this.currCid === '601') {
                prop = 'singleRow-teamLogoPlayer'
              }
              customColumn = {
                prop, //fristColumnPropArr.join('-'),
                label: '运动员',
                // widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              }
            }
          }

          for (let i = 0; i < otherColumns.length; i++) {
            if (i == 0) {
              tableColumnData.push(customColumn)
            }
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              // widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? this.tableCellDefaultWidthVw / 2
              //   : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              // className: ['arrowIcon', 'isExpand'].includes(item.colKey)
              //   ? 'expandTdClassName'
              //   : '', //单独定制的头部样式class
              widthVw:
                item.colKey === 'bib_number'
                  ? 11.1
                  : this.tableCellDefaultWidthVw,
              className: '',
              selected: '',
            })
          }
          this.defaultWidthVwNum = tableColumnData.length - 1 //减去【teamLogo-teamName】
          this.tableColumnData = tableColumnData
        }
        this.tableData = data.data.map((rowData) => {
          return rowData
        })
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableScrollArea {
    position: relative;
    width: 100%;
  }
}
</style>
